import axios from '../erp/configAxiosClean';

export const postUserApi = async (requestData) => {
    return await axios.post('/staff/create/', requestData);
};
